export default __webpack_public_path__ + "static/media/mastercard.de3c3393.svg";